import axios from "axios";

const state = {
    formats: [],
};

export default {
    namespaced: true,
    state,
    getters: {
        getFormats(state) {
            return state.formats;
        },
    },
    actions: {
        getFormatList: async ({ commit }) => {
            const { data } = await axios.get('/api/formats');
            const parsedFormats = data ? 
                Object.keys(data).map((key) => data[key]) : 
                [];

            commit('updateFormatList', parsedFormats);
        },
    },
    mutations: {
        updateFormatList: (state, payload) => 
            state.formats = payload,
    }
};
